import React, {useEffect} from 'react'
import MapView from './map.view'
import { Observer } from 'mobx-react-lite'
import {useAppStore} from "../../../app/store";
import MapController from "../../interfaces/controllers/map.controller";
import MapPresenter from "../../interfaces/presenters/map.presenter";
import CourtEntity from "../../../courts/entities/court.entity";
import { useParams, useSearchParams } from 'react-router-dom';

const MapContainer: React.FC = () => {
  const store = useAppStore()
  const controller = new MapController(store)
  const presenter = new MapPresenter(store)
  const [search, setSearch] = useSearchParams()

  useEffect(() => {
    let lat = search.get('lat')
    let lng = search.get('lng')
    controller.setDefaultLocation(lat, lng)
    controller.getLocation()
  }, [])

  const handleSelectCourt = (court: CourtEntity) => {
    controller.selectCourt(court)
  }

  return (
    <Observer>
      {() => {
        const location = presenter.getLocation()
        const courts = presenter.getCourts()

        return (
          <MapView
            lat={location.lat}
            lng={location.lng}
            courts={courts}
            onChangeCenter={(lat: number, lng: number) => {
              controller.changeLocation(lat, lng)
            }}
            onSelectCourt={handleSelectCourt}
          />
        )
      }}
    </Observer>
  )
}

export default MapContainer
